import { __assign } from 'tslib';
import MuiFormControl from '@mui/material/FormControl';
import React from 'react';
import { F as FormControlContextProvider } from '../../form-control-context-fc570f22.js';

var FormControl = React.forwardRef(function FormControl(props, ref) {
    return (React.createElement(FormControlContextProvider, null,
        React.createElement(MuiFormControl, __assign({}, props, { ref: ref }))));
});

export { FormControl as default };
